import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/Caja/caja';
import HistoriaVentas from './HistoriaVentas';

const mstp = state => {
    return {...state.caja}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(HistoriaVentas)
